'use client';

import { createContext, useContext, useState, ReactNode } from 'react';

type AccordionContextType = {
  activeAccordion: string | null;
  setActiveAccordion: (id: string | null) => void;
};

const AccordionContext = createContext<AccordionContextType>({
  activeAccordion: null,
  setActiveAccordion: () => {},
});

export const AccordionProvider = ({
  children,
  defaultActiveId = null,
}: {
  children: ReactNode;
  defaultActiveId?: string | null;
}) => {
  const [activeAccordion, setActiveAccordion] = useState<string | null>(defaultActiveId);

  const handleAccordion = (item: string | null) => {
    setActiveAccordion(item || defaultActiveId);
  };

  return (
    <AccordionContext.Provider value={{ activeAccordion, setActiveAccordion: handleAccordion }}>
      {children}
    </AccordionContext.Provider>
  );
};

export const useAccordionContext = () => useContext(AccordionContext);
